
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const UserRowSkeleton = () => (
  <tr className="border-b border-secondary-100 dark:border-secondary-800">
    <td className="py-3 px-4">
      <div className="flex items-center gap-3">
        <Skeleton circle width={40} height={40} />
        <div>
          <Skeleton width={100} height={12} />
          <Skeleton width={140} height={10} />
        </div>
      </div>
    </td>
    <td className="py-3 px-4">
      <Skeleton width={60} height={12} />
    </td>
    <td className="py-3 px-4">
      <Skeleton width={80} height={12} />
    </td>
    <td className="py-3 px-4">
      <Skeleton width={50} height={18} />
    </td>
    <td className="py-3 px-4">
      <Skeleton width={90} height={12} />
    </td>
    <td className="py-3 px-4 text-right">
      <Skeleton width={20} height={20} />
    </td>
  </tr>
);


export default UserRowSkeleton;
